// import { useTranslation } from 'react-i18next';
import React from 'react';
import './home.css';
import { useTranslation } from 'react-i18next';
import { HomeText as HomeText_en } from './hometext_en'
import { HomeText as HomeText_es } from './hometext_es'
import { HomeText as HomeText_fr } from './hometext_fr'
import { HomeDiagram as HomeDiagram_en } from './homediagram_en'
import { HomeDiagram as HomeDiagram_es } from './homediagram_es'
import { HomeDiagram as HomeDiagram_fr } from './homediagram_fr'


function Home(){

    const { t, i18n } = useTranslation('common');    

    const getHomeText = () => {
        switch (i18n.language) {
            case 'es': return (<HomeText_es />)
            case 'fr': return (<HomeText_fr />)
            default: return (<HomeText_en />)
        }
    }

    const getHomeDiagram = () => {
        switch (i18n.language) {
            case 'es': return (<HomeDiagram_es />)
            case 'fr': return (<HomeDiagram_fr />)
            default: return (<HomeDiagram_en />)
        }
    }

    return(
        <div className="container-fluid">
            <div className="row">                
                <div className='col-md-4 col-lg-6'>{getHomeText()}</div>
                <div className='col-md-8 col-lg-6'>
                    <div id="home_diagram_container">{getHomeDiagram()}</div>
                </div>
            </div>
        </div>
    );
}

export default Home